const _require = require('../../lib/debug'),
  debugOut = _require.debugOut;
const _require2 = require(/* configBehaviorIgnore: true */'../../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const MAX_TEMPERATURE = 350;
const criteriaTable = [{
  value: 2,
  minimum: 0.01,
  maximum: 0.015
}, {
  value: 2.5,
  minimum: 0.011,
  maximum: 0.0165
}, {
  value: 3,
  minimum: 0.012,
  maximum: 0.018
}, {
  value: 3.5,
  minimum: 0.014,
  maximum: 0.021
}, {
  value: 4,
  minimum: 0.016,
  maximum: 0.024
}, {
  value: 5,
  minimum: 0.016,
  maximum: 0.024
}, {
  value: 6,
  minimum: 0.017,
  maximum: 0.0255
}, {
  value: 7,
  minimum: 0.018,
  maximum: 0.027
}, {
  value: 8,
  minimum: 0.019,
  maximum: 0.0285
}, {
  value: 9,
  minimum: 0.02,
  maximum: 0.03
}, {
  value: 10,
  minimum: 0.021,
  maximum: 0.0315
}, {
  value: 11,
  minimum: 0.022,
  maximum: 0.033
}, {
  value: 12,
  minimum: 0.023,
  maximum: 0.0345
}, {
  value: 13,
  minimum: 0.024,
  maximum: 0.036
}, {
  value: 14,
  minimum: 0.025,
  maximum: 0.0375
}, {
  value: 15,
  minimum: 0.026,
  maximum: 0.039
}, {
  value: 16,
  minimum: 0.027,
  maximum: 0.0405
}, {
  value: 17,
  minimum: 0.028,
  maximum: 0.042
}, {
  value: 18,
  minimum: 0.029,
  maximum: 0.0435
}, {
  value: 19,
  minimum: 0.03,
  maximum: 0.045
}, {
  value: 20,
  minimum: 0.031,
  maximum: 0.0465
}, {
  value: 21,
  minimum: 0.032,
  maximum: 0.048
}, {
  value: 22,
  minimum: 0.033,
  maximum: 0.0495
}, {
  value: 23,
  minimum: 0.034,
  maximum: 0.051
}, {
  value: 24,
  minimum: 0.035,
  maximum: 0.0525
}, {
  value: 25,
  minimum: 0.036,
  maximum: 0.054
}, {
  value: 26,
  minimum: 0.037,
  maximum: 0.0555
}];
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  const operatingTemperature = await evaluateSource(source.operatingTemperature, content, parentContentPath, transientContext, nativeFunctions);
  const gallingMaterial = await evaluateSource(source.gallingMaterial, content, parentContentPath, transientContext, nativeFunctions);
  const field = await evaluateSource(source.field, content, parentContentPath, transientContext, nativeFunctions);
  debugOut('params', source, {
    value,
    operatingTemperature,
    gallingMaterial,
    field
  });
  if (value === undefined) {
    return undefined;
  }
  let criteria = criteriaTable.find(criteriaValue => value < criteriaValue.value);
  if (criteria === undefined) {
    return criteria;
  }
  // need to copy it out of the table.
  criteria = JSON.parse(JSON.stringify(criteria));
  if (operatingTemperature !== undefined && operatingTemperature > MAX_TEMPERATURE) {
    const delta = Math.max(operatingTemperature - MAX_TEMPERATURE - 1, 1) * 0.00002;
    criteria.maximum += delta;
    criteria.minimum += delta;
    criteria.delta = delta;
  }
  if (gallingMaterial !== undefined && gallingMaterial === 'yes') {
    const delta = 0.005;
    criteria.maximum += delta;
    criteria.minimum += delta;
    criteria.delta = delta;
  }
  if (field !== undefined) {
    return criteria[field];
  }
  return criteria;
};
module.exports = {
  evaluate,
  MAX_TEMPERATURE
};